import React, { useState, useEffect } from 'react';
import {
  upload_catering_menu_fromfile,
  getcateringitemlist,
  createcatering_items,
  updatecatering_items,
  deletecatering_items,
  cuisinecategory,
} from '../../../Apiservices/Auth/servers/cateringitems';

import Sidebar from "../Sidebar";
import './CateringBody.css'; // Custom CSS file

function CateringBody() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [file, setFile] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [excludeSideItems, setExcludeSideItems] = useState(false);
  const [cuisineCategories, setCuisineCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  
  // Form state
  const [formData, setFormData] = useState({
    itemName: '',
    description: '',
    categoryId: null, // Set to null
    cuisineCategoryId: '',
    isSideItem: false
  });

  // Fetch items and categories on component mount
  useEffect(() => {
    fetchItems();
    fetchCuisineCategories();
  }, [excludeSideItems]);
// Filter items based on search term
const filteredItems = items.filter(item => 
  item.itemName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  (item.description && item.description.toLowerCase().includes(searchTerm.toLowerCase()))
);
  const fetchItems = async () => {
    setLoading(true);
    try {
      const response = await getcateringitemlist(excludeSideItems);
      if (response.success) {
        // Flatten items from all categories into a single array
        const allItems = response.data.flatMap(category => category.items);
        setItems(allItems);
      }
    } catch (error) {
      console.error('Error fetching items:', error);
      alert('Failed to fetch items');
    } finally {
      setLoading(false);
    }
  };

  const fetchCuisineCategories = async () => {
    setLoadingCategories(true);
    try {
      const response = await cuisinecategory();
      console.log("cuisinecategory",response)
      if (response && Array.isArray(response)) {
        setCuisineCategories(response);
      } else if (response.success && Array.isArray(response.data)) {
        setCuisineCategories(response.data);
      }
    } catch (error) {
      console.error('Error fetching cuisine categories:', error);
      alert('Failed to fetch cuisine categories');
    } finally {
      setLoadingCategories(false);
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Check file type
      const validTypes = [
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel',
        'text/csv'
      ];
      
      if (!validTypes.includes(selectedFile.type)) {
        alert('Please upload an Excel file (.xlsx, .xls) or CSV file');
        return;
      }
      setFile(selectedFile);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      alert('Please select a file to upload');
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await upload_catering_menu_fromfile(formData);
      if (response.success) {
        alert('File uploaded successfully!');
        setFile(null);
        document.getElementById('file-input').value = '';
        fetchItems();
      } else {
        alert('Upload failed: ' + (response.message || 'Unknown error'));
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.itemName.trim()) {
      alert('Item name is required');
      return;
    }

    // Prepare data for API - categoryId is null, cuisineCategoryId can be empty string
    const apiData = {
      itemName: formData.itemName.trim(),
      description: formData.description || '',
      categoryId: null, // Always null as per requirement
      cuisineCategoryId: formData.cuisineCategoryId || null,
      isSideItem: formData.isSideItem
    };

    try {
      if (editingItem) {
        // Update existing item
        const response = await updatecatering_items(apiData, editingItem.id);
        if (response.message === 'Item updated') {
          alert('Item updated successfully!');
          setShowForm(false);
          setEditingItem(null);
          resetForm();
          fetchItems();
        }
      } else {
        // Create new item
        const response = await createcatering_items(apiData);
        if (response.message === 'Item created') {
          alert('Item created successfully!');
          setShowForm(false);
          resetForm();
          fetchItems();
        }
      }
    } catch (error) {
      console.error('Error saving item:', error);
      alert('Failed to save item: ' + (error.message || 'Unknown error'));
    }
  };

  const handleEdit = (item) => {
    setEditingItem(item);
    setFormData({
      itemName: item.itemName,
      description: item.description || '',
      categoryId: null, // Always null
      cuisineCategoryId: item.cuisineCategory?.category_id?.toString() || '',
      isSideItem: item.isSideItem || false
    });
    setShowForm(true);
      window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this item?')) {
      return;
    }

    try {
      const response = await deletecatering_items(id);
      if (response.message === 'Item deleted successfully') {
        alert('Item deleted successfully!');
        fetchItems();
      }
    } catch (error) {
      console.error('Error deleting item:', error);
      alert('Failed to delete item');
    }
  };

  const resetForm = () => {
    setFormData({
      itemName: '',
      description: '',
      categoryId: null,
      cuisineCategoryId: '',
      isSideItem: false
    });
    setEditingItem(null);
  };

  const toggleSideItems = () => {
    setExcludeSideItems(!excludeSideItems);
  };

  return (
    <>
      <Sidebar />
      <div className="catering-container">
        <div className="catering-header">
          <h1>Catering Items Management</h1>
          <div className="header-actions">
  <div className="search-container">
    <input
      type="text"
      placeholder="Search items..."
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="search-input"
    />
    {searchTerm && (
      <button 
        className="clear-search"
        onClick={() => setSearchTerm('')}
        title="Clear search"
      >
        ✕
      </button>
    )}
  </div>
  <button 
    className="btn-primary"
    onClick={() => {
      resetForm();
      setShowForm(!showForm);
    }}
  >
    {showForm ? 'Cancel' : 'Add New Item'}
  </button>
  <button 
    className="btn-secondary"
    onClick={toggleSideItems}
  >
    {excludeSideItems ? 'Show Main Items' : 'Show Side Items'}
  </button>
</div>
        </div>

        {/* File Upload Section */}
        <div className="upload-section">
          <h2>Upload Excel File</h2>
          <div className="upload-controls">
            <input
              id="file-input"
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileChange}
              className="file-input"
            />
            <button
              onClick={handleUpload}
              disabled={!file || uploading}
              className="btn-upload"
            >
              {uploading ? 'Uploading...' : 'Upload File'}
            </button>
            {file && (
              <span className="file-name">
                Selected: {file.name}
              </span>
            )}
          </div>
          <p className="upload-note">
            Upload Excel/CSV file with catering menu items. File should have columns for item names, descriptions, etc.
          </p>
        </div>

        {/* Add/Edit Form */}
        {showForm && (
          <div className="form-section">
            <h2>{editingItem ? 'Edit Item' : 'Add New Item'}</h2>
            <form onSubmit={handleSubmit} className="item-form">
              <div className="form-group">
                <label>Item Name *</label>
                <input
                  type="text"
                  name="itemName"
                  value={formData.itemName}
                  onChange={handleInputChange}
                  placeholder="Enter item name"
                  required
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter description"
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>Cuisine Category</label>
                <select
                  name="cuisineCategoryId"
                  value={formData.cuisineCategoryId}
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="">Select Cuisine Category (Optional)</option>
                  {loadingCategories ? (
                    <option disabled>Loading categories...</option>
                  ) : (
                    cuisineCategories.map((category) => (
                      <option key={category.category_id} value={category.category_id}>
                        {category.category_name}
                      </option>
                    ))
                  )}
                </select>
                {!loadingCategories && cuisineCategories.length === 0 && (
                  <p className="form-hint">No cuisine categories available</p>
                )}
              </div>

              <div className="form-group checkbox-group">
                <input
                  type="checkbox"
                  id="isSideItem"
                  name="isSideItem"
                  checked={formData.isSideItem}
                  onChange={handleInputChange}
                />
                <label htmlFor="isSideItem">Is Side Item</label>
              </div>

              <div className="form-actions">
                <button type="submit" className="btn-submit">
                  {editingItem ? 'Update Item' : 'Create Item'}
                </button>
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => {
                    setShowForm(false);
                    resetForm();
                  }}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Items List */}
        <div className="items-section">
          <h2>Catering Items</h2>
          {loading ? (
            <div className="loading">Loading items...</div>
          ) : filteredItems.length === 0 ? (
  <div className="no-items">
    {searchTerm ? `No items found for "${searchTerm}"` : 'No items found'}
  </div>
          ) : (
            <div className="items-grid">
              {filteredItems.map((item) => (
                <div key={item.id} className="item-card">
                  <div className="item-header">
                    <h3 className="item-name">{item.itemName}</h3>
                    <div className="item-status">
                      <span className={`status-badge ${item.isActive ? 'active' : 'inactive'}`}>
                        {item.isActive ? 'Active' : 'Inactive'}
                      </span>
                      {item.isSideItem && (
                        <span className="side-item-badge">Side Item</span>
                      )}
                    </div>
                  </div>
                  
                  <div className="item-details">
                    {item.description && (
                      <p className="item-description">{item.description}</p>
                    )}
                    
                    {item.cuisineCategory && (
                      <div className="cuisine-category">
                        <strong>Cuisine:</strong> {item.cuisineCategory.name}
                      </div>
                    )}
                  </div>
                  
                  <div className="item-actions">
                    <button
                      className="btn-edit"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default CateringBody;